module.exports = __webpack_public_path__ + "img/appstore-qr.2a6d8f6b.svg";